<template>
	<v-dialog v-model="dialog" max-width="600px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="#1A237E" class="text-lowercase mr-4" dark small v-on="on">add segment</v-btn>
		</template>
		<v-card v-if="!loading">
			<v-card-title class="subtitle-2 pt-6">
				New segment parameters of game <span class="accentColor"> {{ gameId }}</span> & round <span class="accentColor"> {{ round }}</span> 
			</v-card-title>
			<v-card-text class="black--text">
				<v-container grid-list-md>
				<v-form v-model="valid" ref="form" validation>
					<v-row>
						<v-col cols="12" sm="6" md="4">
							<v-text-field dense
								color="#1A237E"
								label="segment name"
								v-model="name"
								name="name"
								type="text"
								:rules="requiredRules">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-select dense
								v-model="type"
								:items="types"
								color="#1A237E"
								item-color="grey"
								label="segment type"
								:rules="requiredRules"
								@change="onceMore()">
							</v-select>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field dense
								color="#1A237E"
								label="peak size"
								v-model.number="peakSize"
								name="peakSize"
								type="text"
								:rules="numberRules"
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field dense
								color="#1A237E"
								label="max price"
								v-model.number="priceMax"
								name="priceMax"
								type="text"
								:rules="numberRules"
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field dense
								color="#1A237E"
								label="min price"
								v-model.number="priceMin"
								name="priceMin"
								type="text"
								:rules="numberRules"
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field dense
								color="#1A237E"
								label="Purchasing habits lowest price"
								v-model.number="lowPrice"
								name="lowPrice"
								type="text"
								:rules="numberRules"
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field dense
								color="#1A237E"
								label="Purchasing habits best quality"
								v-model.number="bestQuality"
								name="bestQuality"
								type="text"
								:rules="numberRules"
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field dense
								color="#1A237E"
								label="Purchasing preferences on-line"
								v-model.number="online"
								name="online"
								type="text"
								:rules="numberRules"
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field dense
								color="#1A237E"
								label="Purchasing preferences off-line"
								v-model.number="offline"
								name="offline"
								type="text"
								:rules="numberRules"
								@change="onceMore()">
							</v-text-field>
						</v-col>
					</v-row>
				</v-form>
				</v-container>
				<v-row justify="center" class="error">{{error}}</v-row>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="#1A237E" text
					class="text-capitalize" 
					@click="closeDialog">
					Close
				</v-btn>
				<v-btn color="#1A237E" text
					class="text-capitalize"
					:disabled="!valid || Boolean(error)"
					@click="addSegment"
					>Save</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>

	export default {
		props: ['gameId', 'round'],
		data () {
			return	{
				dialog: false,
				valid: false,
				error: '',
				types: ['transparent', 'hidden'],
				requiredRules: [v => !!v || 'this field is required'],
				numberRules: [
					v => !!v || 'this field is required',
					v => /^[+]?[0-9]/.test(v) || 'it\'s expected number'
				],
				name: '',
				type: 'transparent',
				peakSize: 0,
				priceMax: 0,
				priceMin: 0,
				lowPrice: 0,
				bestQuality: 0,
				online: 0,
				offline: 0
				
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading
			}
		},
		methods: {
		
			onceMore () {
				this.error = ''
			},
			async addSegment () {

				if(this.$refs.form.validate()) {
					const segment = {
						name: this.name,
						type: this.type,
						peakSize: this.peakSize,
						priceMax: this.priceMax,
						priceMin: this.priceMin,
						lowPrice: this.lowPrice,
						bestQuality: this.bestQuality,
						online: this.online,
						offline: this.offline
					}
					try {
						//add segment 
						await this.$store.dispatch('addSegment', {
							segment: segment,
							gameId: this.gameId,
							round: this.round})
						this.closeDialog ()				
					}
					catch (error) {
						this.$store.dispatch('setError', error.message)//throw error
					}
				}
			},
			closeDialog () {
				//reset
				this.dialog = false
				this.error = ''
			}
		}
	}
</script>
